import React, { FC, memo, useMemo } from 'react';

import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { getActions, withGlobal } from '../../global';
import Input from '../ui/Formik/Input';
import ReCaptcha from '../ui/ReCaptcha';
import Button from '../ui/Button';
import { GlobalState } from '../../global/types';

const initialValue = {
  username: '',
  token: '',
};

type StateProps = Pick<GlobalState, 'authErrorAvailable'>;

const SignInForm: FC<StateProps> = ({ authErrorAvailable }) => {
  const { setAuthEmail, authErrorClear } = getActions();

  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    username: Yup.string()
      .required(t('Validation.required_username_or_email'))
      .min(5, t('Validation.username_min_length')) // min 5
      .max(32, t('Validation.username_max_length')),
    token: Yup.string().required(t('Validation.accept_captcha')),
  });

  const validateUsername = useMemo(() => {
    let errorText = '';
    if (!authErrorAvailable) return errorText;
    return authErrorAvailable.error;
  }, [authErrorAvailable]);

  return (
    <Formik
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {

        setAuthEmail(values);
        setSubmitting(false);
      }}
    >
      {({ isValid, dirty, isSubmitting }) => (
        <Form className='mb-3'>
          <Field
            name='username'
            component={Input}
            label={t('Login.place_username')}
            errorText={validateUsername}
            onClick={authErrorClear}
          />

          <Field name='token' action='login' component={ReCaptcha} />

          <Button
            type='submit'
            fullWidth
            isShiny
            disabled={!dirty || !isValid || isSubmitting}
          >
            {t('Login.sign_in')}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default memo(
  withGlobal((global): StateProps => {
    const { authErrorAvailable } = global;
    return { authErrorAvailable };
  })(SignInForm)
);
